export default {
  priv: 'manage',
  overviewTitle: 'Email Templates',
  detailTitle: 'Email Template',
  deleteTitle: 'deze email template',
  url: '/manage/emails',
  apiUrl: '/emailtemplates/',
  sortBy: ['name'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName: 'manage/emails',
  quickFilter: {
    text: 'Zoek op naam',
    value: 'name',
    type: 'str'
  },
  tableFields: [
    {text: 'Naam', value: 'name', link: '/manage/emails/{id}', width: '30%'},
    {text: 'Ontvangers', value: 'to_recipients', width: '15%'},
    {text: 'CC', value: 'cc_recipients', width: '10%'},
    {text: 'BCC', value: 'bcc_recipients', width: '10%'},
    {text: 'Onderwerp', value: 'subject', width: '15%'},
    // {text: 'Inhoud', value: 'body', width: '15%'},
    // {text: 'Grootte', value: 'file.size', width: '12.5%', filter: 'prettyBytes'},
    {text: 'Envelop', value: 'envelope', width: '5%', type: 'file', align: 'center', sortable: false}
  ]
};
